import React from 'react'
import HeroSection from './components/HeroSection'
import ServiceDesctiption from './components/Description'
import Products from './components/Products'
import CustomerReviews from './components/CustomerReviews'
import WhyChooseUsSection from './components/WhyChooseUs'
import OurCategories from './components/OurCategories'


const ServiceMain = () => {
    return (
        <>
            <HeroSection />
            <ServiceDesctiption />
            <OurCategories />
            <Products />
            <CustomerReviews />
            <WhyChooseUsSection />
        </>
    )
}

export default ServiceMain
